// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;Yet God is my king from of old,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;who did deeds of salvation in the midst of the earth.<br> </p> </div></div>";
// Exports
module.exports = code;